import React, { useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Layout from '../../../Components/Layout/Layout';
import CalendarFilters from '../../../Components/CalendarFilters/Index';
import CalenderModals from '../../../Components/Modals/Index';

const localizer = momentLocalizer(moment);

const CustomToolbar = ({ label, onNavigate }) => {
  return (
    <div className="rbc-toolbar">
      <span className="rbc-btn-group-dash">
        <button type="button" onClick={() => onNavigate('PREV')}>
          &lt;&lt;
        </button>
        <span className="rbc-toolbar-label">{label}</span>
        <button type="button" onClick={() => onNavigate('NEXT')}>
          &gt;&gt;
        </button>
      </span>
    </div>
  );
};

const DailyView = () => {
  const [events, setEvents] = useState([
    {
      title: 'Morning Standup',
      start: new Date(2024, 10, 28, 9, 0),
      end: new Date(2024, 10, 28, 9, 30),
      desc: 'Daily morning meeting to discuss tasks',
      backgroundColor: '#a3d9f5',
      textColor: '#07477d',
    },
    {
      title: 'Client Presentation',
      start: new Date(2024, 10, 28, 14, 0),
      end: new Date(2024, 10, 28, 15, 30),
      desc: 'Present project updates to the client',
      backgroundColor: '#f3abab',
      textColor: '#7d1c1c',
    },
  ]);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const handleEventClick = (event) => {
    setSelectedEvent(event);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedEvent(null);
  };

  const eventPropGetter = (event) => ({
    style: {
      backgroundColor: event.backgroundColor,
      color: event.textColor,
      padding: '5px 5px',
      border: 'none',
    },
  });

  return (
    <Layout>
      <CalendarFilters />
      <div style={{ height: '80vh', margin: '20px' }}>
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          style={{ height: '100%' }}
          eventPropGetter={eventPropGetter}
          view="day" // Always show daily view
          onView={() => {}} // Disable view change
          components={{
            toolbar: CustomToolbar,
            event: ({ event }) => (
              <div
                className="custom-event"
                onClick={() => handleEventClick(event)}
              >
                <strong
                  style={{
                    backgroundColor: event.textColor,
                    color: event.backgroundColor,
                  }}
                >
                  {event.title}
                </strong>
                <span>{event.desc}</span>
              </div>
            ),
          }}
        />
      </div>
      <CalenderModals
          open={modalOpen}
          onClose={handleModalClose}
          event={selectedEvent}
        />
    </Layout>
  );
};

export default DailyView;
